import { defineComponent } from 'vue';

export default defineComponent({
  name: 'sectionHeader',
  props: {
    text: {
      type: String,
      required: true,
    },
    noTopMargin: {
      type: Boolean,
      default: false,
    },
    noBottomMargin: {
      type: Boolean,
      default: false,
    },
  },
});
